<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <div class="box"
         :style="{'backgroundImage':'url(' + $imgUrl+ 'home/bj/bj2.jpg)','backgroundSize':'100% 100%' ,'backgroundRepeat': 'no-repeat'}">
      <div class="currency_box flexCenter"
           style="font-size:48px;">
        专业提供定制化人才培养方案
      </div>
      <div class="currency_box flexCenter"
           style="font-size:48px;margin-bottom: 50px;">
        致力于零售行业人才专业能力提升
      </div>
      <div class="currency_boxs flexCenter">
        <div class="form_box">
          <div class="dh font24">咨询顾问专线： <span style="color:#FFAE00">180-7108-3230</span></div>
          <div class="ts font14">请填写以下信息，我们会在24小时内与您联系为您提供定制化的企业培训方案</div>
          <el-form ref="form"
                   :rules="rules"
                   :model="form">
            <el-form-item prop="enterpriseName">
              <el-input placeholder="您的企业名称"
                        maxlength="30"
                        @input="form.enterpriseName = form.enterpriseName.replace(/\s+/g,'')"
                        v-model.trim="form.enterpriseName"></el-input>
            </el-form-item>
            <el-form-item prop="employeeNum">
              <el-input placeholder="您的企业员工人数"
                        type="number"
                        @input="employeeNumChange"
                        v-model.number="form.employeeNum"></el-input>
            </el-form-item>
            <el-form-item prop="userName">
              <el-input placeholder="您的称呼"
                        maxlength="10"
                        @input="form.userName = form.userName.replace(/\s+/g,'')"
                        v-model.trim="form.userName"></el-input>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input placeholder="您的电话"
                        maxlength="11"
                        v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button style="width:100%;background-color: #DE1F26;height:65px;"
                         type="primary"
                         @click="sumbit">立即提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import curriculumItem from '@/components/OnlineBusinessSchool/curriculum_item.vue'
import { formAddApply } from '@/api/api.js'
export default {
  components: { curriculumItem },
  data () {
    const validateMobile = (rule, value, callback) => {
      let regPhone = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
      if (value === '') {
        callback(new Error('请填写您的手机号'));
      } else if (!regPhone.test(value)) {
        callback(new Error('请输入正确的手机号格式!'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        userName: [
          { required: true, message: '请输入您的称呼', trigger: 'blur' },
        ],
        phone: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        enterpriseName: [
          { required: true, message: '请输入您的企业名称', trigger: 'blur' }
        ],
        employeeNum: [
          { required: true, message: '请输入您的企业员工人数', trigger: 'blur' }
        ]
      },
      form: {
        fromType: 1,
        miniType: 1,
        enterpriseName: '',
        employeeNum: '',
        userName: '',
        phone: ''
      },
      type: '',  // 19私董会申请   17线下活动
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
    }
  },
  created () {
    this.init()
  },
  methods: {
    employeeNumChange (e) {
      let num = e.replace(".", "")
      console.log(num)
      this.form.employeeNum = num;
      if (Number(num) <= 0) {
        this.form.employeeNum = 1;
      }
      if (Number(num) >= 99999) {
        this.form.employeeNum = 99999;
      }
    },
    init () {
      if (this.$route.query.type) {
        // type  19  私董会
        this.type = this.$route.query.type
        console.log(this.type)
        switch (Number(this.type)) {
          case 19: //私董会
            this.form.fromType = 3;
            this.form.miniType = 1;
            break;
          case 15:  //商学院申请  minitype 2 线上商学院  4  畅学年卡
            this.form.fromType = 3;
            this.form.miniType = this.$route.query.miniType == 0 ? 2 : 4;
            break;
          case 17:  //线下活动报名
            this.form.fromType = 5;
            this.form.miniType = '';
            break;
        }
        console.log(this.form)
      }
    },
    sumbit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.getFormAddApply()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      // this.getFormAddApply()
    },
    getFormAddApply () {
      formAddApply(this.form).then(res => {
        if (res && res.code == 200) {
          this.$router.push('/Status?type=' + this.type)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  // min-height: 100vh;
  background-color: #fff;
  .box {
    min-width: 1200px;
    min-height: calc(100vh - 511px);
    // background-color: #000000;
    color: #fff;
    padding: 100px 0;
    box-sizing: border-box;
    .form_box {
      max-width: 728px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 10px;
      padding: 30px 40px;
      box-sizing: border-box;
      .dh {
        text-align: center;
      }
      .ts {
        text-align: center;
        margin: 20px 0 30px;
        color: #ffffff;
      }
    }
  }
}
</style>
